export default "__VITE_ASSET__F69uZMta__"